const $ = jQuery.noConflict();

const hero = $('.page-hero');

class FixedHeader {
    constructor() {
        this.header = $('header.main-header');
        this.headerHeight = this.header.outerHeight(true);
    }
    updateHederHeight() {
        this.headerHeight = this.header.outerHeight(true);
    }
    makeHeaderFixed() {
        $('body').css({
            'padding-top': this.headerHeight,
        });

        this.header.addClass('fixed');
    }
    undoFixedHeader() {
        this.header.removeClass('fixed');
        $('body').css({
            'padding-top': '',
        });
    }
    scrollFunc() {
        const heroOffset = (hero.length !== 0) ? hero.offset().top + hero.outerHeight(true) : 250;
        if ($(window).scrollTop() > heroOffset) {
            this.makeHeaderFixed();
        } else {
            this.undoFixedHeader();
        }
    }
}

export default new FixedHeader();
